import React from 'react';
import { useTranslation } from 'react-i18next';
import { withBasePath } from 'shared/utils/runtimeBasePath';

export default function EventBoxBase({ eventId }) {
  const { t } = useTranslation();
  if (eventId == null || String(eventId).trim() === '') return null;
  return (
    <div className="event-box" aria-label={t('EVENT_NUMBER')}>
      <div className="event-info">
        <span className="event-box-event-id-label">{t('EVENT_NUMBER')}</span>
        <br />
        <span className="hash">#</span>
        <span className="event-box-event-id">{String(eventId)}</span>
      </div>
      <div className="event-box-logo">
        <img src={withBasePath('/images/baseball/event-box-logo.png')} alt="Event logo" />
      </div>
    </div>
  );
}
